export const S_EMBED_ANALYTICS_EVENT_MESSAGE_TYPE = "S_EMBED_ANALYTICS_EVENT";

export type SEmbedPosthogConfig = {
  key: string;
  host?: string;
};

export type SEmbedAnalyticsEventMessage = {
  type: typeof S_EMBED_ANALYTICS_EVENT_MESSAGE_TYPE;
  event: string;
  properties: Record<string, unknown>;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function isSEmbedAnalyticsEventMessage(
  value: unknown,
): value is SEmbedAnalyticsEventMessage {
  return (
    isRecord(value) &&
    value.type === S_EMBED_ANALYTICS_EVENT_MESSAGE_TYPE &&
    typeof value.event === "string" &&
    value.event.length > 0 &&
    isRecord(value.properties)
  );
}
